export default "__VITE_ASSET__C1cOO2WY__"